import { useNavigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import ManageMembersGroup, { type Action } from 'modules/posts/components/Groups/ManageMembers'

const ManageMembersGroupPage = ({ action }: { action: Action }) => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  return (
    <ManageMembersGroup
      action={action}
      onClose={() => navigate(navigation.dashboard.fullPath())}
      groupId={Number(id)}
    />
  )
}

export default ManageMembersGroupPage
